/* tslint:disable */
/* eslint-disable */
/**
 * Web MMB BFF API
 * Version of Backend for Frontend API (mid-layer between FE and MMB API) designed for web frontend purposes.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SegmentAdditionalInfoGroupFromJSON, SegmentAdditionalInfoGroupToJSON, } from './SegmentAdditionalInfoGroup';
import { ThrowawayItineraryDataFromJSON, ThrowawayItineraryDataToJSON, } from './ThrowawayItineraryData';
import { SegmentCarrierFromJSON, SegmentCarrierToJSON, } from './SegmentCarrier';
import { StopFromJSON, StopToJSON, } from './Stop';
import { SegmentConnectionNumberFromJSON, SegmentConnectionNumberToJSON, } from './SegmentConnectionNumber';
import { SegmentVehicleTypeFromJSON, SegmentVehicleTypeToJSON, } from './SegmentVehicleType';
import { SegmentHiddenFromJSON, SegmentHiddenToJSON, } from './SegmentHidden';
import { HiddenCityDataFromJSON, HiddenCityDataToJSON, } from './HiddenCityData';
import { SegmentDurationFromJSON, SegmentDurationToJSON, } from './SegmentDuration';
import { SegmentCabinClassFromJSON, SegmentCabinClassToJSON, } from './SegmentCabinClass';
import { SegmentLayoverFromJSON, SegmentLayoverToJSON, } from './SegmentLayover';
/**
 * Check if a given object implements the Segment interface.
 */
export function instanceOfSegment(value) {
    if (!('arrival' in value) || value['arrival'] === undefined)
        return false;
    if (!('departure' in value) || value['departure'] === undefined)
        return false;
    if (!('duration' in value) || value['duration'] === undefined)
        return false;
    if (!('vehicleType' in value) || value['vehicleType'] === undefined)
        return false;
    return true;
}
export function SegmentFromJSON(json) {
    return SegmentFromJSONTyped(json, false);
}
export function SegmentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'additionalInfoGroups': json['additional_info_groups'] == null ? undefined : (json['additional_info_groups'].map(SegmentAdditionalInfoGroupFromJSON)),
        'arrival': StopFromJSON(json['arrival']),
        'cabinClass': json['cabin_class'] == null ? undefined : SegmentCabinClassFromJSON(json['cabin_class']),
        'carrier': json['carrier'] == null ? undefined : SegmentCarrierFromJSON(json['carrier']),
        'connectionNumber': json['connection_number'] == null ? undefined : SegmentConnectionNumberFromJSON(json['connection_number']),
        'departure': StopFromJSON(json['departure']),
        'duration': SegmentDurationFromJSON(json['duration']),
        'hidden': json['hidden'] == null ? undefined : SegmentHiddenFromJSON(json['hidden']),
        'hiddenArrivalInfo': json['hidden_arrival_info'] == null ? undefined : HiddenCityDataFromJSON(json['hidden_arrival_info']),
        'layover': json['layover'] == null ? undefined : SegmentLayoverFromJSON(json['layover']),
        'throwAwayInfo': json['throw_away_info'] == null ? undefined : ThrowawayItineraryDataFromJSON(json['throw_away_info']),
        'vehicleType': SegmentVehicleTypeFromJSON(json['vehicle_type']),
    };
}
export function SegmentToJSON(json) {
    return SegmentToJSONTyped(json, false);
}
export function SegmentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'additional_info_groups': value['additionalInfoGroups'] == null ? undefined : (value['additionalInfoGroups'].map(SegmentAdditionalInfoGroupToJSON)),
        'arrival': StopToJSON(value['arrival']),
        'cabin_class': SegmentCabinClassToJSON(value['cabinClass']),
        'carrier': SegmentCarrierToJSON(value['carrier']),
        'connection_number': SegmentConnectionNumberToJSON(value['connectionNumber']),
        'departure': StopToJSON(value['departure']),
        'duration': SegmentDurationToJSON(value['duration']),
        'hidden': SegmentHiddenToJSON(value['hidden']),
        'hidden_arrival_info': HiddenCityDataToJSON(value['hiddenArrivalInfo']),
        'layover': SegmentLayoverToJSON(value['layover']),
        'throw_away_info': ThrowawayItineraryDataToJSON(value['throwAwayInfo']),
        'vehicle_type': SegmentVehicleTypeToJSON(value['vehicleType']),
    };
}
